<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { useAlertStore } from '@/stores';
  const alertStore = useAlertStore();
  const { alerts } = storeToRefs(alertStore);
</script>

<template>
  <div class="card bg-sky-50 mt-4 text-sm" role="alert" v-for="(alert, index) in alerts" :key="index">
    <span v-html="alert"></span>
  </div>
</template>

<style lang="scss" scoped></style>
